"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLIENT_EVENTS = exports.SupportedMethods = void 0;
var SupportedMethods;
(function (SupportedMethods) {
  SupportedMethods["accounts"] = "eth_accounts";
  SupportedMethods["signTransaction"] = "eth_signTransaction";
  SupportedMethods["personalSign"] = "personal_sign";
  SupportedMethods["signTypedData"] = "eth_signTypedData";
  SupportedMethods["decrypt"] = "personal_decrypt";
  SupportedMethods["computeSharedSecret"] = "personal_computeSharedSecret";
})(SupportedMethods = exports.SupportedMethods || (exports.SupportedMethods = {}));
// Note: Pulled events from https://docs.walletconnect.com/client-api#register-event-subscription
var CLIENT_EVENTS;
(function (CLIENT_EVENTS) {
  CLIENT_EVENTS["connect"] = "connect";
  CLIENT_EVENTS["disconnect"] = "disconnect";
  CLIENT_EVENTS["session_request"] = "session_request";
  CLIENT_EVENTS["session_update"] = "session_update";
  CLIENT_EVENTS["call_request"] = "call_request";
  CLIENT_EVENTS["wc_sessionRequest"] = "wc_sessionRequest";
  CLIENT_EVENTS["wc_sessionUpdate"] = "wc_sessionUpdate";
})(CLIENT_EVENTS = exports.CLIENT_EVENTS || (exports.CLIENT_EVENTS = {}));